<template>
<div>
<ContentOverlay ></ContentOverlay>
<div class="content_card" v-if="item">





<div class="grid">

<!--sidebar-->
<ItemSidebar :name="$store.state.sections.section.name" 
:brand="$store.state.sections.section.brand"
:project="$store.state.sections.section.project"
:questionlist="$store.state.sections.section.questionlist"
></ItemSidebar>
<!--sidebar-->




<div class="col-12 md:col-10">
<div class="content_card_content">
<TabNavigation :tabs="tabs"></TabNavigation>
<router-view></router-view>

</div>
</div>

</div>




</div>
 </div> 
</template>

<script>
export default {

  name: 'Section',

  data () {
    return {
      item:null,
      tabs: [
      {
          title: 'bolum',
          icon: 'list',
          route: 'general',
      },
      {
          title: 'ceviriler',
          icon: 'info-circle',
          route: 'translations',
      },
      ],

    }
  },
  mounted()
  {    
    this.getData()
    this.checkTabName(this.tabs)
  },
  methods:{
  	async getData()
    {
        let item = await this.generalApiGet("questionlists/section/"+this.$route.params.id)
        console.log(item)
        
        await this.$store.dispatch('sections/setSection',item) 
        this.item = await item
    },
  }
};
</script>

<style lang="css" scoped>
</style>